import React from "react";
import { connect } from "react-redux";

import KeywordSearch from "../../../sharedComponents/keywordSearch";
import { searchExercises, resetField } from "../../../store/actions";
import Tooltip from "../../../sharedComponents/tooltip";

const ExerciseHeader = ({ searchExercises, resetField, toggleAdvancedFilterPanel }) => {
	return (
		<div className="d-flex">
			<h3 className="flex-fill m-0">Exercises</h3>
			<div className="d-flex">
				<KeywordSearch
					placeholder="Search Exercises"
					searchField="name"
					searchAction={(event) => {
						resetField("Exercises.exercisesSearchKeyword", event ? event : "");
					}}
					name="searchExercise"
					className="mr-2"
				/>
				<Tooltip content="Filter">
					<button className="btn btn-primary-dark btn-ghost btn-icon" onClick={toggleAdvancedFilterPanel}>
						<i className="icon icon-filter" />
					</button>
				</Tooltip>
			</div>
		</div>
	);
};
const mapDispatchToProps = { searchExercises, resetField };

export default connect(
	null,
	mapDispatchToProps
)(ExerciseHeader);
